import { NgModule } from "@angular/core";
import { sharedModule } from "src/app/shared/shared.module";
import { ContractComponent } from "./contract/contract.component";
import { ContractListComponent } from "./contract/contract-list/contract-list.component";
import { ContractEntryComponent } from "./contract/contract-entry/contract-entry.component";
import { ContractRoleComponent } from "./contract/contract-entry/contract-role/contract-role.component";
import { SmsVarificationEntryComponent } from "./contract/sms-varification-entry/sms-varification-entry.component";
import { ContractDetailComponent } from './contract/contract-detail/contract-detail.component';
import { ContractLeavingJobComponent } from './contract/contract-leaving-job/contract-leaving-job.component';
import { ContractEditComponent } from './contract/contract-entry/contract-edit/contract-edit.component';
import { ContractSearchComponent } from './contract/contract-search/contract-search.component';
import { ContractExtensionComponent } from './contract/contract-extension/contract-extension.component';

@NgModule({
  declarations: [
    ContractComponent,
    ContractListComponent,
    ContractRoleComponent,
    ContractEntryComponent,
    SmsVarificationEntryComponent,
    ContractDetailComponent,
    ContractLeavingJobComponent,
    ContractEditComponent,
    ContractSearchComponent,
    ContractExtensionComponent
  ],
  imports: [sharedModule],
  entryComponents: [
    ContractEntryComponent,
    SmsVarificationEntryComponent,
    ContractDetailComponent,
    ContractExtensionComponent,
    ContractLeavingJobComponent,
    ContractEditComponent,ContractSearchComponent]
})
export class hrmModule { }
